import { normalizeSearch } from "../../components/AdminWorkspace";
import { Link as RouterLink } from "react-router-dom";
import { TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useCallback
} from "react";
import { SiOpenai } from "react-icons/si";
import { toast } from "react-toastify";
import "./mobile-styles.css";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Button,
  ButtonBase,
  IconButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
  Collapse,
  useMediaQuery,
  Menu,
  MenuItem,
  Fab,
  Slide,
  ClickAwayListener,
  Tooltip,
  ButtonGroup
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  Add as AddIcon,
  ExpandLess,
  ExpandMore,
  Save as SaveIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  ChevronLeft,
  ChevronRight
} from "@material-ui/icons";
import WebAssetIcon from '@material-ui/icons/WebAsset';
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";

import HttpIcon from "@mui/icons-material/Http";
import DataObjectIcon from "@mui/icons-material/DataObject";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CompareArrows from "@mui/icons-material/CompareArrows";

import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  useReactFlow
} from "react-flow-renderer";

import {
  AccessTime,
  CallSplit,
  DynamicFeed,
  Image,
  ImportExport,
  LibraryBooks,
  Message,
  MicNone,
  RocketLaunch,
  Videocam,
  Tag,
  Queue,
  Person
} from "@mui/icons-material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Import dos nós (mantendo os mesmos)
import messageNode from "./nodes/messageNode.js";
import startNode from "./nodes/startNode";
import openaiNode from "./nodes/openaiNode";
import geminiNode from "./nodes/geminiNode";
//import conditionNode from "./nodes/conditionNode";
import menuNode from "./nodes/menuNode";
import intervalNode from "./nodes/intervalNode";
import imgNode from "./nodes/imgNode";
import randomizerNode from "./nodes/randomizerNode";
import videoNode from "./nodes/videoNode";
import switchFlowNode from "./nodes/switchFlowNode";
import attendantNode from "./nodes/attendantNode";
import RemoveEdge from "./nodes/removeEdge";
import audioNode from "./nodes/audioNode";
import { useNodeStorage } from "../../stores/useNodeStorage";
import singleBlockNode from "./nodes/singleBlockNode";
import ticketNode from "./nodes/ticketNode";
import erpNode from "./nodes/erpNode";
import readMediaNode from "./nodes/readMediaNode";
import tagNode from "./nodes/tagNode";
//import conditionCompareNode from "./nodes/conditionCompareNode";
import HttpRequestNode from "./nodes/httpRequestNode";
import removeTagNode from "./nodes/removeTagNode";
import VariableNode, {
  getFlowVariable,
  setFlowVariable,
} from "./nodes/variableNode";
import inputNode from "./nodes/inputNode";

// Imports dos modais (mantendo os mesmos)
import FlowBuilderAddImgModal from "../../components/FlowBuilderAddImgModal";
import FlowBuilderTicketModal from "../../components/FlowBuilderAddTicketModal";
import FlowBuilderErpModal from "../../components/FlowBuilderErpModal";
import FlowBuilderReadMediaModal from "../../components/FlowBuilderReadMediaModal";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FlowBuilderAddAudioModal from "../../components/FlowBuilderAddAudioModal";
import FlowBuilderAddTagModal from "../../components/FlowBuilderAddTagModal";
import FlowBuilderRandomizerModal from "../../components/FlowBuilderRandomizerModal";
import FlowBuilderAddVideoModal from "../../components/FlowBuilderAddVideoModal";
import FlowBuilderSingleBlockModal from "../../components/FlowBuilderSingleBlockModal";
import FlowBuilderAddTextModal from "../../components/FlowBuilderAddTextModal";
import FlowBuilderIntervalModal from "../../components/FlowBuilderIntervalModal";
//import FlowBuilderConditionModal from "../../components/FlowBuilderConditionModal";
import FlowBuilderMenuModal from "../../components/FlowBuilderMenuModal";
import FlowBuilderAddSwitchFlowModal from "../../components/FlowBuilderAddSwitchFlowModal";
import FlowBuilderAddAttendantModal from "../../components/FlowBuilderAddAttendantModal";
import FlowBuilderInputModal from "../../components/FlowBuilderInputModal";
//import FlowBuilderConditionCompareModal from "../../components/FlowBuilderConditionCompareModal";
import FlowBuilderRemoveTagModal from "../../components/FlowBuilderRemoveTagModal";
import FlowBuilderOpenAIModal from "../../components/FlowBuilderAddOpenAIModal";
import FlowBuilderGeminiModal from "../../components/FlowBuilderGeminiModal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CircularProgress } from "@material-ui/core";
import { getTokens, TOPBAR, INK, brandAlpha, shadeBrand } from "../../styles/tokens";



const useStyles = makeStyles(theme => {
  const tk = getTokens(theme.palette.type, theme.palette.primary.main);
  const dark = tk.mode === "dark";
  const strong = dark ? tk.text : INK[800];
  return {
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: `calc(100vh - ${TOPBAR.height}px)`,
    minHeight: 0,
    overflow: "hidden",
    backgroundColor: tk.page,
    fontFamily: tk.font,
    [theme.breakpoints.down("sm")]: {
      height: `calc(100dvh - ${TOPBAR.compact}px)`,
    },
  },
  // Barra do editor: compacta, para o canvas ficar com a altura
  header: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: 12,
    minHeight: 60,
    padding: "8px 20px",
    backgroundColor: tk.paper,
    borderBottom: `1px solid ${tk.line}`,
    zIndex: 3,
    [theme.breakpoints.down("sm")]: {
      padding: "8px 12px",
      gap: 8,
    },
  },
  backButton: {
    flex: "none",
    padding: 8,
    color: tk.textSecondary,
    border: `1px solid ${tk.line}`,
  },
  headerText: {
    flex: 1,
    minWidth: 0,
  },
  flowTitle: {
    margin: 0,
    fontFamily: tk.font,
    fontSize: 17,
    fontWeight: 700,
    lineHeight: 1.3,
    letterSpacing: "-0.015em",
    color: tk.text,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  builderStats: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    columnGap: 8,
    marginTop: 2,
    color: tk.textSecondary,
    fontSize: 12,
    lineHeight: 1.5,
    fontVariantNumeric: "tabular-nums",
  },
  statDot: {
    width: 3,
    height: 3,
    borderRadius: "50%",
    backgroundColor: tk.lineStrong,
  },
  statHint: {
    color: tk.textMuted,
    [theme.breakpoints.down("md")]: { display: "none" },
  },
  headerActions: {
    flex: "none",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  content: {
    flex: 1,
    display: "flex",
    position: "relative",
    overflow: "hidden"
  },
  // Biblioteca de blocos (desktop), recolhível
  sidebar: {
    width: props => props.sidebarOpen ? 292 : 64,
    margin: 12,
    marginRight: 0,
    overflow: "hidden",
    backgroundColor: tk.paper,
    border: `1px solid ${tk.line}`,
    borderRadius: tk.radius.md,
    boxShadow: tk.shadow.card,
    transition: `width ${tk.motion.slow}`,
    display: "flex",
    flexDirection: "column",
    zIndex: 4,
    [theme.breakpoints.down('md')]: {
      display: "none" // em telas menores a biblioteca abre na folha inferior
    }
  },
  sidebarHeader: {
    padding: "0 10px 0 14px",
    borderBottom: `1px solid ${tk.line}`,
    display: "flex",
    alignItems: "center",
    justifyContent: props => props.sidebarOpen ? "space-between" : "center",
    minHeight: 48,
    backgroundColor: tk.muted,
  },
  sidebarTitle: {
    color: strong,
    fontSize: 13.5,
    fontWeight: 600,
  },
  collapseButton: {
    padding: 6,
    color: tk.textSecondary,
  },
  sidebarSearch: {
    padding: "12px 12px 4px",
  },
  sidebarEmpty: {
    padding: "20px 16px",
    fontSize: 13,
    color: tk.textSecondary,
  },
  sidebarContent: {
    flex: 1,
    overflowY: "auto",
    padding: "8px 8px 12px",
    ...theme.scrollbarStyles
  },
  flowContainer: {
    flex: 1,
    position: "relative",
    margin: 12,
    overflow: "hidden",
    backgroundColor: tk.muted,
    border: `1px solid ${tk.line}`,
    borderRadius: tk.radius.md,
    boxShadow: tk.shadow.card,
    '& .react-flow__controls': {
      bottom: 16,
      left: 16,
      overflow: "hidden",
      backgroundColor: tk.paper,
      border: `1px solid ${tk.line}`,
      borderRadius: tk.radius.sm,
      boxShadow: tk.shadow.soft,
      "& button": {
        width: 20,
        height: 20,
        padding: 6,
        color: tk.textSecondary,
        backgroundColor: tk.paper,
        borderBottom: `1px solid ${tk.line}`,
        "&:last-child": { borderBottom: 0 },
        "& svg": { fill: "currentColor", maxWidth: 14, maxHeight: 14 },
        "&:hover": { color: tk.brand, backgroundColor: tk.muted },
      },
      [theme.breakpoints.down('md')]: {
        display: 'none' // abaixo de 1280px valem os controles grandes (MobileControls)
      }
    },
    "& .react-flow__minimap": {
      overflow: "hidden",
      backgroundColor: tk.paper,
      border: `1px solid ${tk.line}`,
      borderRadius: tk.radius.sm,
      boxShadow: tk.shadow.soft,
    },
    [theme.breakpoints.down("sm")]: {
      margin: 8,
    },
  },
  // Folha inferior (telas menores)
  bottomSheet: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: tk.paper,
    borderRadius: `${tk.radius.lg}px ${tk.radius.lg}px 0 0`,
    boxShadow: tk.shadow.lift,
    zIndex: 1500,
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${tk.line}`,
    borderBottom: 0,
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  bottomSheetHandle: {
    width: 40,
    height: 4,
    backgroundColor: tk.lineStrong,
    borderRadius: 2,
    margin: "8px auto",
    cursor: "pointer"
  },
  bottomSheetHeader: {
    padding: "4px 12px 10px 16px",
    borderBottom: `1px solid ${tk.line}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: strong,
    fontSize: 15,
    fontWeight: 600,
  },
  bottomSheetContent: {
    flex: 1,
    overflowY: "auto",
    padding: 12,
    ...theme.scrollbarStyles
  },
  // Salvar (telas menores): a ação fica flutuando sobre o canvas
  fab: {
    position: "fixed",
    right: theme.spacing(2),
    bottom: theme.spacing(9),
    zIndex: 1400,
    backgroundColor: tk.brand,
    color: tk.brandOn,
    boxShadow: tk.shadow.soft,
    '&:hover': {
      backgroundColor: tk.brandHover,
    },
    [theme.breakpoints.up('lg')]: {
      display: "none",
    }
  },
  addFab: {
    position: "fixed",
    bottom: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 1400,
    backgroundColor: tk.paper,
    color: tk.brand,
    border: `1px solid ${tk.line}`,
    boxShadow: tk.shadow.soft,
    '&:hover': {
      backgroundColor: tk.muted,
    },
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  // Biblioteca: grupo e itens
  categoryHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "7px 8px",
    marginTop: 4,
    borderRadius: tk.radius.badge,
    color: tk.textSecondary,
    fontFamily: tk.font,
    fontSize: 12,
    fontWeight: 600,
    textAlign: "left",
    '&:hover': {
      backgroundColor: tk.muted,
      color: strong,
    },
    "&:focus-visible": { outline: `2px solid ${tk.brand}`, outlineOffset: -2 },
    "& .MuiSvgIcon-root": { fontSize: 18, color: tk.textMuted },
  },
  nodeList: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "2px 0 6px",
  },
  nodeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 10,
    width: "100%",
    minHeight: 46,
    padding: "6px 8px",
    borderRadius: tk.radius.sm,
    textAlign: "left",
    fontFamily: tk.font,
    transition: `background-color ${tk.motion.fast}`,
    "&:hover": { backgroundColor: tk.muted },
    "&:focus-visible": { outline: `2px solid ${tk.brand}`, outlineOffset: -2 },
  },
  nodeTile: {
    flex: "none",
    width: 30,
    height: 30,
    borderRadius: tk.radius.badge,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": { width: 17, height: 17, fontSize: 17 },
  },
  nodeText: { minWidth: 0, display: "flex", flexDirection: "column" },
  nodeName: {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.35,
    color: strong,
  },
  nodeDesc: {
    fontSize: 11.5,
    lineHeight: 1.35,
    color: tk.textSecondary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  collapsedGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    padding: "4px 0",
    "& + &": { borderTop: `1px solid ${tk.line}`, marginTop: 4, paddingTop: 8 },
  },
  collapsedNodeButton: {
    width: 40,
    height: 40,
    padding: 5,
    borderRadius: tk.radius.sm,
    '&:hover': { backgroundColor: tk.muted },
  },
  // Atalhos sobre o canvas (desktop)
  quickActions: {
    position: "absolute",
    top: 12,
    right: 12,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: 4,
    zIndex: 5,
    backgroundColor: tk.paper,
    border: `1px solid ${tk.line}`,
    borderRadius: tk.radius.sm,
    boxShadow: tk.shadow.soft,
    [theme.breakpoints.down('md')]: {
      display: "none"
    }
  },
  quickActionButton: {
    padding: 7,
    color: tk.textSecondary,
    borderRadius: tk.radius.badge,
    "& svg": { fontSize: 20 },
    "&:hover": {
      backgroundColor: tk.tint.soft,
      color: tk.brand,
    }
  },
  // Zoom em telas menores
  mobileControls: {
    position: "fixed",
    bottom: 80,
    left: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    zIndex: 1300,
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  controlButton: {
    backgroundColor: tk.paper,
    boxShadow: tk.shadow.soft,
    width: 44,
    height: 44,
    color: tk.textSecondary,
    border: `1px solid ${tk.line}`,
    "&:hover": {
      backgroundColor: tk.muted,
      color: tk.brand,
    }
  },
  sheetGroup: {
    "& + &": { marginTop: 8 },
  },
  sheetGroupTitle: {
    padding: "6px 8px",
    fontSize: 12,
    fontWeight: 600,
    color: tk.textSecondary,
  },
  sheetGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 4,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "minmax(0, 1fr)" },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: tk.page,
  }
  };
});

// Definição das categorias de nós
const nodeCategories = [
  {
    name: "Básicos",
    color: theme => theme.palette.primary.main,
    icon: <RocketLaunch />,
    nodes: [
      {
        icon: <RocketLaunch />,
        name: "Início",
        type: "start",
        description: "Ponto inicial do fluxo"
      }
    ]
  },
  {
    name: "Conteúdo",
    color: theme => theme.palette.success.main,
    icon: <LibraryBooks />,
    nodes: [
      {
        icon: <LibraryBooks />,
        name: "Conteúdo",
        type: "content",
        description: "Enviar texto, imagem, áudio ou vídeo"
      },
      {
        icon: <Message />,
        name: "Texto",
        type: "text",
        description: "Mensagem de texto simples"
      }
    ]
  },
  {
    name: "Interação",
    color: theme => theme.palette.warning.main,
    icon: <DynamicFeed />,
    nodes: [
      {
        icon: <DynamicFeed />,
        name: "Menu",
        type: "menu",
        description: "Menu de opções para o usuário"
      },
      {
        icon: <QuestionAnswerIcon />,
        name: "Input",
        type: "input",
        description: "Coletar entrada do usuário"
      },
      {
        icon: <AccessTime />,
        name: "Intervalo",
        type: "interval",
        description: "Pausar execução por tempo"
      }
    ]
  },
  {
    name: "Lógica",
    color: theme => theme.palette.secondary.main,
    icon: <CallSplit />,
    nodes: [
      {
        icon: <CallSplit />,
        name: "Randomizador",
        type: "random",
        description: "Escolha aleatória de caminhos"
      }
    ]
  },
  {
    name: "Sistema",
    color: theme => theme.palette.info.main,
    icon: <Queue />,
    nodes: [
      {
        icon: <Queue />,
        name: "Filas",
        type: "ticket",
        description: "Gerenciar filas de atendimento"
      },
      {
        icon: <Tag />,
        name: "Tags",
        type: "tag",
        description: "Adicionar tags ao contato"
      },
      {
        icon: <Tag />,
        name: "Remover Tag",
        type: "removeTag",
        description: "Remover tags do contato"
      },
      {
        icon: <ArrowForwardIcon />,
        name: "Trocar Flow",
        type: "switchFlow",
        description: "Direcionar para outro fluxo"
      },
      {
        icon: <Person />,
        name: "Atendente",
        type: "attendant",
        description: "Transferir para atendente"
      }
    ]
  },
  {
    name: "Integrações",
    color: theme => theme.palette.error.main,
    icon: <HttpIcon />,
    nodes: [
      {
        icon: <HttpIcon />,
        name: "HTTP Request",
        type: "httpRequest",
        description: "Requisição HTTP externa"
      },
      {
        icon: <Queue />,
        name: "ERP / Agente IA",
        type: "erp",
        description: "SGP/IXC ou agente de IA do setor"
      },
      {
        icon: <AttachFileIcon />,
        name: "Ler arquivo (IA)",
        type: "readMedia",
        description: "Cliente envia foto/PDF e a IA lê"
      },
      {
        icon: <DataObjectIcon />,
        name: "Variável",
        type: "variable",
        description: "Definir variáveis globais"
      },
      {
        icon: <SiOpenai />,
        name: "Gemini",
        type: "gemini",
        description: "Integração com Gemini"
      },
      {
        icon: <SiOpenai />,
        name: "OpenAI",
        type: "openai",
        description: "Integração com OpenAI/"
      }
    ]
  }
];

// Tom do quadradinho de ícone a partir da cor da categoria (tema)
const categoryTone = (category, theme) => {
  const color = typeof category.color === "function" ? category.color(theme) : category.color;
  const dark = theme.palette.type === "dark";
  return {
    backgroundColor: brandAlpha(color, dark ? 0.24 : 0.12),
    color: dark ? shadeBrand(color, 0.4) : color,
  };
};

// Função para gerar string aleatória (mantida igual)
function geraStringAleatoria(tamanho) {
  var stringAleatoria = "";
  var caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < tamanho; i++) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

// Tipos de nós (mantido igual)
const nodeTypes = {
  message: messageNode,
  start: startNode,
  //condition: conditionNode,
  menu: menuNode,
  interval: intervalNode,
  img: imgNode,
  gemini: geminiNode,
  audio: audioNode,
  randomizer: randomizerNode,
  video: videoNode,
  singleBlock: singleBlockNode,
  ticket: ticketNode,
  erp: erpNode,
  readMedia: readMediaNode,
  tag: tagNode,
  removeTag: removeTagNode,
  switchFlow: switchFlowNode,
  attendant: attendantNode,
  httpRequest: HttpRequestNode,
  variable: VariableNode,
  openai: openaiNode,
  input: inputNode,
  //conditionCompare: conditionCompareNode,
};

const edgeTypes = {
  buttonedge: RemoveEdge
};

const initialNodes = [
  {
    id: "1",
    position: { x: 250, y: 100 },
    data: { label: "Inicio do fluxo" },
    type: "start"
  }
];

const initialEdges = [];

// Função para detectar se é mobile
const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0)
  );
};

// Componente de controles customizados para mobile
const MobileControls = () => {
  const classes = useStyles();
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  return (
    <div className={classes.mobileControls}>
      <IconButton
        onClick={() => zoomIn()}
        className={classes.controlButton}
        size="small"
        aria-label="Aproximar"
      >
        <ZoomInIcon />
      </IconButton>

      <IconButton
        onClick={() => zoomOut()}
        className={classes.controlButton}
        size="small"
        aria-label="Afastar"
      >
        <ZoomOutIcon />
      </IconButton>

      <IconButton
        onClick={() => fitView({ padding: 0.2 })}
        className={classes.controlButton}
        size="small"
        aria-label="Enquadrar o fluxo"
      >
        <WebAssetIcon />
      </IconButton>
    </div>
  );
};

// Componente de ações rápidas para desktop
const QuickActions = ({ onActionClick }) => {
  const classes = useStyles();

  const quickActions = [
    { icon: <Message />, name: "Texto", type: "text" },
    { icon: <DynamicFeed />, name: "Menu", type: "menu" },
    { icon: <AccessTime />, name: "Intervalo", type: "interval" },
    { icon: <LibraryBooks />, name: "Conteúdo", type: "content" }
  ];

  return (
    <div className={classes.quickActions} role="toolbar" aria-label="Adicionar bloco rápido">
      {quickActions.map((action) => (
        <Tooltip key={action.type} title={`Adicionar ${action.name}`} placement="left">
          <IconButton
            onClick={() => onActionClick(action.type)}
            className={classes.quickActionButton}
            aria-label={`Adicionar ${action.name}`}
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </div>
  );
};

export const FlowBuilderConfig = () => {
  const theme = useTheme();
  const tk = getTokens(theme.palette.type, theme.palette.primary.main);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { id } = useParams();

  // Estados para interface
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [nodeSearch, setNodeSearch] = useState("");
  const [flowName, setFlowName] = useState("");
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState(null);
  const filteredCategories = nodeCategories.map(category => ({ ...category, nodes: category.nodes.filter(node => normalizeSearch(`${category.name} ${node.name} ${node.description}`).includes(normalizeSearch(nodeSearch))) })).filter(category => category.nodes.length);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
  // a biblioteca abre com todos os grupos à mostra; o usuário recolhe o que não usa
  const [expandedCategories, setExpandedCategories] = useState(() => nodeCategories.map(category => category.name));

  const classes = useStyles({ sidebarOpen });

  // Estados existentes (mantidos)
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [dataNode, setDataNode] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  // Estados dos modais (mantidos)
  const [modalAddText, setModalAddText] = useState(null);
  const [modalAddInterval, setModalAddInterval] = useState(false);
  //const [modalAddCondition, setModalAddCondition] = useState(null);
  const [modalAddMenu, setModalAddMenu] = useState(null);
  const [modalAddImg, setModalAddImg] = useState(null);
  const [modalAddAudio, setModalAddAudio] = useState(null);
  const [modalAddRandomizer, setModalAddRandomizer] = useState(null);
  const [modalAddVideo, setModalAddVideo] = useState(null);
  const [modalAddSingleBlock, setModalAddSingleBlock] = useState(null);
  const [modalAddTicket, setModalAddTicket] = useState(null);
  const [modalAddErp, setModalAddErp] = useState(null);
  const [modalAddReadMedia, setModalAddReadMedia] = useState(null);
  const [modalAddTag, setModalAddTag] = useState(null);
  const [modalAddSwitchFlow, setModalAddSwitchFlow] = useState(null);
  const [modalAddAttendant, setModalAddAttendant] = useState(null);
  const [modalAddOpenAI, setModalAddOpenAI] = useState(null);
  const [modalAddGemini, setModalAddGemini] = useState(null);
  const [modalAddInput, setModalAddInput] = useState(null);
  //const [modalAddConditionCompare, setModalAddConditionCompare] = useState(null);
  const [modalAddRemoveTag, setModalAddRemoveTag] = useState(null);

  // Estados ReactFlow (mantidos)
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const storageItems = useNodeStorage();

  const connectionLineStyle = {
    stroke: theme.palette.primary.main,
    strokeWidth: 2
  };

  // Inicializar sistema de variáveis globais
  useEffect(() => {
    if (!window.flowVariables) {
      window.flowVariables = {};
      console.log("Sistema de variáveis globais inicializado");
    }
    window.getFlowVariable = getFlowVariable;
    window.setFlowVariable = setFlowVariable;
  }, []);

  // Função addNode COMPLETA (mantida igual - muito longa para reproduzir aqui)
  const addNode = (type, data) => {
    const posY = nodes.length ? nodes[nodes.length - 1].position.y : 100;
    const posX = nodes.length ? nodes[nodes.length - 1].position.x + (nodes[nodes.length - 1].width || 200) + 40 : 100;

    if (type === "start") {
      return setNodes(old => {
        return [
          ...old.filter(item => item.id !== "1"),
          {
            id: "1",
            position: { x: posX, y: posY },
            data: { label: "Inicio do fluxo" },
            type: "start"
          }
        ];
      });
    }

    if (type === "text") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { label: data.text },
            type: "message"
          }
        ];
      });
    }

    if (type === "interval") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { label: `Intervalo ${data.sec} seg.`, sec: data.sec },
            type: "interval"
          }
        ];
      });
    }

    if (type === "menu") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              message: data.message,
              arrayOption: data.arrayOption,
              ...(data.atalhoDatasNodeId
                ? { atalhoDatasNodeId: data.atalhoDatasNodeId }
                : {}),
              ...(data.textoLivreNodeId
                ? { textoLivreNodeId: data.textoLivreNodeId }
                : {})
            },
            type: "menu"
          }
        ];
      });
    }

    if (type === "img") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url },
            type: "img"
          }
        ];
      });
    }

    if (type === "audio") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, record: data.record },
            type: "audio"
          }
        ];
      });
    }

    if (type === "randomizer") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { percent: data.percent },
            type: "randomizer"
          }
        ];
      });
    }

    if (type === "video") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url },
            type: "video"
          }
        ];
      });
    }

    if (type === "singleBlock") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "singleBlock"
          }
        ];
      });
    }

    if (type === "ticket") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "ticket"
          }
        ];
      });
    }

    if (type === "erp") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "erp"
          }
        ];
      });
    }

    if (type === "readMedia") {
      return setNodes(old => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: { ...data },
          type: "readMedia"
        }
      ]);
    }

    if (type === "openai") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "openai",
          },
        ];
      });
    }

    if (type === "gemini") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "gemini",
          },
        ];
      });
    }

    if (type === "tag") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "tag"
          }
        ];
      });
    }

    if (type === "removeTag") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              tag: data?.tag || "",
              ...data,
            },
            type: "removeTag",
          },
        ];
      });
    }

    if (type === "switchFlow") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "switchFlow"
          }
        ];
      });
    }

    if (type === "attendant") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "attendant"
          }
        ]
      })
    }

    if (type === "httpRequest") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: {
            url: "",
            method: data?.method || "POST",
            requestBody: data?.requestBody || "{}",
            headersString: data?.headersString || "",
            queryParams: data?.queryParams || [],
            saveVariables: data?.saveVariables || [],
            ...data,
          },
          type: "httpRequest",
        },
      ]);
    }

    if (type === "variable") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              variableName: data?.variableName || "",
              variableValue: data?.variableValue || "",
              variableType: data?.variableType || "text",
              variableExpression: data?.variableExpression || "",
              isExpression: data?.isExpression || false,
              ...data,
            },
            type: "variable",
          },
        ];
      });
    }

    if (type === "input") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              question: data?.question || "",
              variableName: data?.variableName || "",
              ...data,
            },
            type: "input",
          },
        ];
      });
    }
  };

  // Funções de adição (mantidas)
  const textAdd = data => addNode("text", data);
  const intervalAdd = data => addNode("interval", data);
  //const conditionAdd = data => addNode("condition", data);
  const menuAdd = data => addNode("menu", data);
  const imgAdd = data => addNode("img", data);
  const audioAdd = data => addNode("audio", data);
  const randomizerAdd = data => addNode("randomizer", data);
  const videoAdd = data => addNode("video", data);
  const singleBlockAdd = data => addNode("singleBlock", data);
  const ticketAdd = data => addNode("ticket", data);
  const erpAdd = data => addNode("erp", data);
  const readMediaAdd = data => addNode("readMedia", data);
  const tagAdd = data => addNode("tag", data);
  const openaiAdd = data => addNode("openai", data);
  const geminiAdd = data => addNode("gemini", data);
  const removeTagAdd = data => addNode("removeTag", data);
  const switchFlowAdd = data => addNode("switchFlow", data);
  const attendantAdd = data => addNode("attendant", data);
  const variableAdd = data => addNode("variable", data);
  const inputAdd = data => addNode("input", data);

  // useEffect para carregar fluxo COMPLETO (mantido)
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get(`/flowbuilder/flow/${id}`);
          setFlowName(data.flow.name || "");
          if (data.flow.flow !== null) {
            const preparedNodes = data.flow.flow.nodes.map((node) => {
              if (node.type === "httpRequest") {
                console.log(`[FlowBuilder] Processando nó HTTP Request: ${node.id}`);

                if (node.data.saveVariables && node.data.saveVariables.length > 0) {
                  console.log(
                    `[FlowBuilder] Nó ${node.id} tem ${node.data.saveVariables.length} variáveis configuradas`
                  );

                  if (
                    !node.data.responseVariables ||
                    !Array.isArray(node.data.responseVariables)
                  ) {
                    console.log(
                      `[FlowBuilder] Configurando responseVariables para nó ${node.id}`
                    );
                    node.data.responseVariables = node.data.saveVariables.map(
                      (item) => ({
                        path: item.path,
                        variableName: item.variable,
                      })
                    );
                  }
                } else {
                  node.data.saveVariables = node.data.saveVariables || [];
                  node.data.responseVariables = node.data.responseVariables || [];
                }

                console.log(`[FlowBuilder] Nó HTTP Request ${node.id} processado:`, {
                  url: node.data.url,
                  method: node.data.method,
                  saveVariables: node.data.saveVariables?.length || 0,
                  responseVariables: node.data.responseVariables?.length || 0,
                });
              }
              return node;
            });

            setNodes(preparedNodes);
            setEdges(data.flow.flow.connections);
          }
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [id]);

  // useEffect para storage COMPLETO (mantido)
  useEffect(() => {
    if (storageItems.action === "delete") {
      setNodes(old => old.filter(item => item.id !== storageItems.node));
      setEdges(old => {
        const newData = old.filter(item => item.source !== storageItems.node);
        const newClearTarget = newData.filter(
          item => item.target !== storageItems.node
        );
        return newClearTarget;
      });
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
    if (storageItems.action === "duplicate") {
      const nodeDuplicate = nodes.filter(
        item => item.id === storageItems.node
      )[0];
      const maioresX = nodes.map(node => node.position.x);
      const maiorX = Math.max(...maioresX);
      const finalY = nodes[nodes.length - 1].position.y;
      const nodeNew = {
        ...nodeDuplicate,
        id: geraStringAleatoria(30),
        position: {
          x: maiorX + 240,
          y: finalY
        },
        selected: false,
        style: {
          backgroundColor: theme.palette.grey[800],
          padding: 0,
          borderRadius: 8,
          border: `1px solid ${theme.palette.divider}`
        }
      };
      setNodes(old => [...old, nodeNew]);
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
  }, [storageItems.action, nodes, theme]);

  const onConnect = useCallback(
    params => setEdges(eds => addEdge(params, eds)),
    [setEdges]
  );

  // Função de salvar COMPLETA (mantida)
  const saveFlow = async () => {
    if (saving) return;
    setSaving(true);
    try {
      console.log("[FlowBuilder] Preparando para salvar fluxo...");
      const processedNodes = nodes.map((node) => {
        if (node.type === "httpRequest") {
          console.log(`[FlowBuilder] Processando nó HTTP Request: ${node.id}`);
          if (node.data.saveVariables && node.data.saveVariables.length > 0) {
            console.log(
              `[FlowBuilder] Nó ${node.id} tem ${node.data.saveVariables.length} variáveis configuradas`
            );

            if (
              !node.data.responseVariables ||
              !Array.isArray(node.data.responseVariables)
            ) {
              console.log(
                `[FlowBuilder] Configurando responseVariables para nó ${node.id}`
              );
              node.data.responseVariables = node.data.saveVariables.map(
                (item) => ({
                  path: item.path,
                  variableName: item.variable,
                })
              );
            }
          } else {
            node.data.saveVariables = node.data.saveVariables || [];
            node.data.responseVariables = node.data.responseVariables || [];
          }

          console.log(`[FlowBuilder] Nó HTTP Request ${node.id} processado:`, {
            url: node.data.url,
            method: node.data.method,
            saveVariables: node.data.saveVariables?.length || 0,
            responseVariables: node.data.responseVariables?.length || 0,
          });
        }
        return node;
      });

      console.log("[FlowBuilder] Enviando fluxo para o servidor...");

      await api
        .post("/flowbuilder/flow", {
          idFlow: id,
          nodes: processedNodes,
          connections: edges,
        })
        .then((res) => {
          toast.success("Fluxo salvo com sucesso");
          setSavedAt(new Date());
          setNodes(processedNodes);
        });
    } catch (error) {
      toast.error("Erro ao salvar o fluxo");
      console.error("Erro ao salvar o fluxo:", error);
    } finally {
      setSaving(false);
    }
  };

  // Event handlers COMPLETOS (mantidos mas adaptados para tema)
  const doubleClick = (event, node) => {
    setDataNode(node);
    if (node.type === "message") setModalAddText("edit");
    if (node.type === "interval") setModalAddInterval("edit");
    if (node.type === "menu") setModalAddMenu("edit");
    if (node.type === "img") setModalAddImg("edit");
    if (node.type === "audio") setModalAddAudio("edit");
    if (node.type === "randomizer") setModalAddRandomizer("edit");
    if (node.type === "video") setModalAddVideo("edit");
    if (node.type === "singleBlock") setModalAddSingleBlock("edit");
    if (node.type === "ticket") setModalAddTicket("edit");
    if (node.type === "erp") setModalAddErp("edit");
    if (node.type === "readMedia") setModalAddReadMedia("edit");
    if (node.type === "tag") setModalAddTag("edit");
    if (node.type === "removeTag") setModalAddRemoveTag("edit");
    if (node.type === "switchFlow") setModalAddSwitchFlow("edit");
    if (node.type === "openai") setModalAddOpenAI("edit");
    if (node.type === "gemini") setModalAddGemini("edit");
    if (node.type === "attendant") setModalAddAttendant("edit");
    if (node.type === "httpRequest") {
      if (node.data.saveVariables && node.data.saveVariables.length > 0) {
        if (
          !node.data.responseVariables ||
          !Array.isArray(node.data.responseVariables)
        ) {
          node.data.responseVariables = node.data.saveVariables.map((item) => ({
            path: item.path,
            variableName: item.variable,
          }));

          setNodes((old) =>
            old.map((itemNode) => {
              if (itemNode.id === node.id) {
                return node;
              }
              return itemNode;
            })
          );

          console.log("[FlowBuilder] Nó HTTP Request atualizado:", node.id);
        }
      }
    }
    if (node.type === "input") setModalAddInput("edit");
  };

  const clickNode = (event, node) => {
    setNodes(old =>
      old.map(item => {
        if (item.id === node.id) {
          return {
            ...item,
            style: {
              backgroundColor: theme.palette.primary.main,
              padding: 1,
              borderRadius: 8,
              border: `2px solid ${theme.palette.primary.dark}`
            }
          };
        }
        return {
          ...item,
          style: {
            backgroundColor: theme.palette.grey[800],
            padding: 0,
            borderRadius: 8,
            border: `1px solid ${theme.palette.divider}`
          }
        };
      })
    );
  };

  const clickEdge = (event, node) => {
    setNodes(old =>
      old.map(item => {
        return {
          ...item,
          style: {
            backgroundColor: theme.palette.grey[800],
            padding: 0,
            borderRadius: 8,
            border: `1px solid ${theme.palette.divider}`
          }
        };
      })
    );
  };

  const updateNode = dataAlter => {
    setNodes(old =>
      old.map(itemNode => {
        if (itemNode.id === dataAlter.id) {
          return dataAlter;
        }
        return itemNode;
      })
    );
    // Fechar todos os modais
    setModalAddText(null);
    setModalAddInterval(null);
    setModalAddMenu(null);
    setModalAddImg(null);
    setModalAddOpenAI(null);
    setModalAddAudio(null);
    setModalAddRandomizer(null);
    setModalAddVideo(null);
    setModalAddGemini(null);
    setModalAddSingleBlock(null);
    setModalAddTicket(null);
    setModalAddErp(null);
    setModalAddReadMedia(null);
    setModalAddRemoveTag(null);
    setModalAddTag(null);
    setModalAddSwitchFlow(null);
    setModalAddAttendant(null);
    setModalAddInput(null);
  };

  // Handler para categoria expand/collapse
  const handleCategoryToggle = (categoryName) => {
    setExpandedCategories(prev =>
      prev.includes(categoryName)
        ? prev.filter(name => name !== categoryName)
        : [...prev, categoryName]
    );
  };

  // Handler para ações de nós
  const clickActions = type => {
    setBottomSheetOpen(false);

    switch (type) {
      case "start":
        addNode("start");
        break;
      case "menu":
        setModalAddMenu("create");
        break;
      case "content":
        setModalAddSingleBlock("create");
        break;
      case "text":
        setModalAddText("create");
        break;
      case "random":
        setModalAddRandomizer("create");
        break;
      case "interval":
        setModalAddInterval("create");
        break;
      case "ticket":
        setModalAddTicket("create");
        break;
      case "erp":
        setModalAddErp("create");
        break;
      case "readMedia":
        setModalAddReadMedia("create");
        break;
      case "tag":
        setModalAddTag("create");
        break;
      case "removeTag":
        setModalAddRemoveTag("create");
        break;
      case "switchFlow":
        setModalAddSwitchFlow("create");
        break;
      case "attendant":
        setModalAddAttendant("create");
        break;
      case "httpRequest":
        addNode("httpRequest");
        break;
      case "variable":
        addNode("variable");
        break;
      case "input":
        setModalAddInput("create");
        break;
      case "openai":
        setModalAddOpenAI("create");
        break;
      case "gemini":
        setModalAddGemini("create");
        break;
      case "img":
        setModalAddImg("create");
        break;
      case "audio":
        setModalAddAudio("create");
        break;
      case "video":
        setModalAddVideo("create");
        break;
      default:
    }
  };

  // Biblioteca de blocos — função de render (não componente): não remonta a cada render do editor
  const renderSidebarContent = () => (
    <div className={classes.sidebarContent}>
      {filteredCategories.map((category) => (
        <div key={category.name}>
          {sidebarOpen ? (
            // Modo expandido
            <>
              <ButtonBase
                className={classes.categoryHeader}
                onClick={() => handleCategoryToggle(category.name)}
                aria-expanded={Boolean(nodeSearch) || expandedCategories.includes(category.name)}
              >
                <span>{category.name}</span>
                {expandedCategories.includes(category.name) ? <ExpandLess /> : <ExpandMore />}
              </ButtonBase>

              <Collapse in={Boolean(nodeSearch) || expandedCategories.includes(category.name)}>
                <div className={classes.nodeList}>
                  {category.nodes.map((node) => (
                    <ButtonBase
                      key={node.type}
                      className={classes.nodeButton}
                      onClick={() => clickActions(node.type)}
                    >
                      <span className={classes.nodeTile} style={categoryTone(category, theme)} aria-hidden="true">
                        {node.icon}
                      </span>
                      <span className={classes.nodeText}>
                        <span className={classes.nodeName}>{node.name}</span>
                        <span className={classes.nodeDesc}>{node.description}</span>
                      </span>
                    </ButtonBase>
                  ))}
                </div>
              </Collapse>
            </>
          ) : (
            // Modo colapsado - só ícones
            <div className={classes.collapsedGroup}>
              {category.nodes.map((node) => (
                <Tooltip key={node.type} title={node.name} placement="right">
                  <IconButton
                    className={classes.collapsedNodeButton}
                    onClick={() => clickActions(node.type)}
                    aria-label={`Adicionar ${node.name}`}
                  >
                    <span className={classes.nodeTile} style={categoryTone(category, theme)} aria-hidden="true">
                      {node.icon}
                    </span>
                  </IconButton>
                </Tooltip>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  // Folha inferior — idem
  const renderBottomSheet = () => (
    <Slide direction="up" in={bottomSheetOpen} mountOnEnter unmountOnExit>
      <div className={classes.bottomSheet}>
        <div
          className={classes.bottomSheetHandle}
          onClick={() => setBottomSheetOpen(false)}
        />

        <div className={classes.bottomSheetHeader}>
          <span>Adicionar bloco</span>
          <IconButton onClick={() => setBottomSheetOpen(false)} size="small" aria-label="Fechar">
            <CloseIcon />
          </IconButton>
        </div>

        <div className={classes.bottomSheetContent}>
          {filteredCategories.map((category) => (
            <div className={classes.sheetGroup} key={category.name}>
              <div className={classes.sheetGroupTitle}>{category.name}</div>
              <div className={classes.sheetGrid}>
                {category.nodes.map((node) => (
                  <ButtonBase
                    key={node.type}
                    className={classes.nodeButton}
                    onClick={() => clickActions(node.type)}
                  >
                    <span className={classes.nodeTile} style={categoryTone(category, theme)} aria-hidden="true">
                      {node.icon}
                    </span>
                    <span className={classes.nodeText}>
                      <span className={classes.nodeName}>{node.name}</span>
                      <span className={classes.nodeDesc}>{node.description}</span>
                    </span>
                  </ButtonBase>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Slide>
  );

  const backButton = (
    <Tooltip title="Voltar para os fluxos">
      <IconButton
        component={RouterLink}
        to="/flowbuilders"
        className={classes.backButton}
        aria-label="Voltar para os fluxos"
      >
        <ChevronLeft />
      </IconButton>
    </Tooltip>
  );

  if (loading) {
    return (
      <div className={classes.root}>
        <div className={classes.header}>
          {backButton}
          <div className={classes.headerText}>
            <h1 className={classes.flowTitle}>Editor de fluxo</h1>
            <div className={classes.builderStats}>Carregando automação…</div>
          </div>
        </div>
        <div className={classes.loadingContainer}>
          <CircularProgress color="primary" />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        {backButton}
        <div className={classes.headerText}>
          <h1 className={classes.flowTitle} title={flowName || undefined}>{flowName || "Editor de fluxo"}</h1>
          <div className={classes.builderStats}>
            <span>{nodes.length} blocos</span>
            <span className={classes.statDot} />
            <span>{edges.length} conexões</span>
            <span className={classes.statDot} />
            <span>{saving ? "Salvando…" : savedAt ? `Último salvamento às ${savedAt.toLocaleTimeString("pt-BR")}` : "Salve após editar"}</span>
            <span className={`${classes.statDot} ${classes.statHint}`} />
            <span className={classes.statHint}>Dois cliques em um bloco para configurá-lo</span>
          </div>
        </div>
        {!isMobile && (
          <div className={classes.headerActions}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={saveFlow}
              disabled={saving}
            >
              {saving ? "Salvando…" : "Salvar fluxo"}
            </Button>
          </div>
        )}
      </div>

      {/* Content */}
      <div className={classes.content}>
        {/* Sidebar Desktop */}
        {!isMobile && (
          <div className={classes.sidebar}>
            <div className={classes.sidebarHeader}>
              {sidebarOpen && (
                <span className={classes.sidebarTitle}>
                  Biblioteca de blocos
                </span>
              )}
              <IconButton
                onClick={() => setSidebarOpen(!sidebarOpen)}
                size="small"
                className={classes.collapseButton}
                aria-label={sidebarOpen ? "Recolher biblioteca" : "Expandir biblioteca"}
              >
                {sidebarOpen ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            </div>
            {sidebarOpen && (
              <div className={classes.sidebarSearch}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Buscar bloco…"
                  value={nodeSearch}
                  onChange={event => setNodeSearch(event.target.value)}
                  inputProps={{ "aria-label": "Buscar bloco" }}
                  InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
                />
              </div>
            )}
            {sidebarOpen && !filteredCategories.length && <div className={classes.sidebarEmpty}>Nenhum bloco encontrado.</div>}
            {renderSidebarContent()}
          </div>
        )}

        {/* Flow Container */}
        <div className={classes.flowContainer}>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            deleteKeyCode={["Backspace", "Delete"]}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onNodeDoubleClick={doubleClick}
            onNodeClick={clickNode}
            onEdgeClick={clickEdge}
            onConnect={onConnect}
            nodeTypes={nodeTypes}
            fitView
            connectionLineStyle={connectionLineStyle}
            edgeTypes={edgeTypes}
            variant={"cross"}
            defaultEdgeOptions={{
              style: { stroke: theme.palette.primary.main, strokeWidth: 2 },
              animated: false
            }}
          >
            <Controls />
            <MiniMap
              nodeColor={tk.lineStrong}
              nodeStrokeColor={tk.lineStrong}
              nodeBorderRadius={4}
              maskColor={brandAlpha(tk.page, 0.72)}
            />
            <Background variant="dots" gap={20} size={1} color={tk.lineStrong} />
          </ReactFlow>

          {/* Atalhos sobre o canvas (desktop) */}
          {!isMobile && <QuickActions onActionClick={clickActions} />}
        </div>
      </div>

      {/* Mobile Controls */}
      {isMobile && <MobileControls />}

      {/* Salvar em telas menores (a barra não mostra o botão) */}
      <Fab
        color="primary"
        className={classes.fab}
        onClick={saveFlow}
        disabled={saving}
        title="Salvar fluxo"
        aria-label="Salvar fluxo"
      >
        <SaveIcon />
      </Fab>

      {/* Bottom Sheet Mobile */}
      {isMobile && renderBottomSheet()}

      {/* FAB Adicionar - só em mobile */}
      {isMobile && (
        <Fab
          className={classes.addFab}
          onClick={() => setBottomSheetOpen(true)}
          aria-label="Adicionar bloco"
        >
          <AddIcon />
        </Fab>
      )}

      {/* Click Away Listener para Bottom Sheet */}
      {isMobile && bottomSheetOpen && (
        <ClickAwayListener onClickAway={() => setBottomSheetOpen(false)}>
          <div />
        </ClickAwayListener>
      )}

      {/* TODOS OS MODAIS COMPLETOS - mantidos iguais */}
      <FlowBuilderAddTextModal
        open={modalAddText}
        onSave={textAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddText}
      />
      <FlowBuilderIntervalModal
        open={modalAddInterval}
        onSave={intervalAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddInterval}
      />
      <FlowBuilderMenuModal
        open={modalAddMenu}
        onSave={menuAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddMenu}
        nodes={nodes}
      />
      <FlowBuilderAddImgModal
        open={modalAddImg}
        onSave={imgAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddImg}
      />
      <FlowBuilderAddAudioModal
        open={modalAddAudio}
        onSave={audioAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddAudio}
      />
      <FlowBuilderRandomizerModal
        open={modalAddRandomizer}
        onSave={randomizerAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddRandomizer}
      />
      <FlowBuilderAddVideoModal
        open={modalAddVideo}
        onSave={videoAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddVideo}
      />
      <FlowBuilderSingleBlockModal
        open={modalAddSingleBlock}
        onSave={singleBlockAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddSingleBlock}
      />
      <FlowBuilderTicketModal
        open={modalAddTicket}
        onSave={ticketAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddTicket}
      />
      <FlowBuilderErpModal
        open={modalAddErp}
        onSave={erpAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddErp}
      />
      <FlowBuilderReadMediaModal
        open={modalAddReadMedia}
        onSave={readMediaAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddReadMedia}
      />
      <FlowBuilderOpenAIModal
        open={modalAddOpenAI}
        onSave={openaiAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddOpenAI}
      />
      <FlowBuilderGeminiModal
        open={modalAddGemini}
        onSave={geminiAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddGemini}
      />
      <FlowBuilderAddTagModal
        open={modalAddTag}
        onSave={tagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddTag}
      />
      <FlowBuilderRemoveTagModal
        open={modalAddRemoveTag}
        onSave={removeTagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddRemoveTag(null)}
      />
      <FlowBuilderAddSwitchFlowModal
        open={modalAddSwitchFlow}
        onSave={switchFlowAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddSwitchFlow}
      />
      <FlowBuilderAddAttendantModal
        open={modalAddAttendant}
        onSave={attendantAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddAttendant}
      />
      <FlowBuilderInputModal
        open={modalAddInput}
        onSave={inputAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddInput}
      />
    </div>
  );
};
